"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("firebase/firestore");
const chart_js_1 = require("chart.js");
const globals_1 = require("../../infra/globals");
const utils_1 = require("../../infra/utils");
const date_utils_1 = require("../../infra/date_utils");
const country_1 = require("../../models/country");
const game_records_table_1 = __importDefault(require("../components/game_records_table"));
const ui_utils_1 = require("../ui_utils");
const elo_1 = __importDefault(require("../../models/elo"));
class PlayerView extends HTMLElement {
    playerRef;
    static tag = "player-view";
    constructor(playerRef) {
        super();
        this.playerRef = playerRef;
    }
    getPlayer = async () => {
        const playerDoc = await (0, firestore_1.getDoc)((0, firestore_1.doc)(globals_1.db, "players", this.playerRef));
        this.player = (0, utils_1.addFirebaseRef)(playerDoc.data(), playerDoc.id);
    };
    async connectedCallback() {
        document.title = "Jogador";
        await this.getPlayer();
        document.title = `Jogador | ${this.player.name}`;
        this.setPlayersPage();
        this.setGraph();
        this.appendChild(new game_records_table_1.default("Partidas", this.playerRef));
    }
    setGraph = () => {
        const eloHistory = this.player.eloHistory;
        const dateData = eloHistory.map((ded) => date_utils_1.DateUtils.formatDate(new Date(ded.date)));
        const eloData = eloHistory.map((ded) => ded.eloDelta ? ded.atTheTimeElo + ded.eloDelta : ded.atTheTimeElo);
        chart_js_1.Chart.register(...chart_js_1.registerables);
        const canvasDiv = document.createElement("div");
        canvasDiv.id = "graph";
        canvasDiv.innerHTML = `<h2>Evolução Elo</h2>`;
        const graphCanvas = document.createElement("canvas");
        canvasDiv.appendChild(graphCanvas);
        this.appendChild(canvasDiv);
        const ctx = graphCanvas.getContext("2d");
        new chart_js_1.Chart(ctx, {
            type: "line",
            data: {
                labels: dateData,
                datasets: [
                    {
                        fill: true,
                        data: eloData,
                        backgroundColor: ["rgba(54, 162, 235, 0.2)"],
                        borderColor: ["rgba(54, 162, 235, 1)"],
                        borderWidth: 1.5,
                    },
                ],
            },
            options: {
                plugins: {
                    legend: {
                        display: false,
                    },
                },
                scales: {
                    x: {
                        ticks: {
                            autoSkip: true,
                            maxTicksLimit: 12,
                            maxRotation: 45,
                            minRotation: 45,
                            font: {
                                size: 15,
                            },
                        },
                    },
                    y: {
                        ticks: {
                            font: {
                                size: 16,
                            },
                        },
                    },
                },
            },
        });
    };
    setPlayersPage = () => {
        const countryFlags = ui_utils_1.UiUtils.allFlags(this.player.nationalities);
        const picture = this.player.picture
            ? `<img src="${this.player.picture}"/>`
            : "";
        this.innerHTML += `
      <div id="name">
        ${picture}
        <h1>${this.player.name} ${countryFlags}</h1>
      </div>
    `;
        this.setPlayerCard();
    };
    get ofOrigin() {
        let [statesOfOrigin, citiesOfOrigin] = ["", ""];
        for (const c of this.player.nationalities) {
            if (c.state)
                statesOfOrigin += statesOfOrigin.length > 0 ? ", " + c.state : c.state;
            if (c.city)
                citiesOfOrigin += citiesOfOrigin.length > 0 ? ", " + c.city : c.city;
        }
        if (statesOfOrigin === "")
            statesOfOrigin = globals_1.emdash;
        if (citiesOfOrigin === "")
            citiesOfOrigin = globals_1.emdash;
        return [statesOfOrigin, citiesOfOrigin];
    }
    setPlayerCard = () => {
        const elo = new elo_1.default(this.player.currentElo);
        const email = this.player.email ? this.player.email : globals_1.emdash;
        let [statesOfOrigin, citiesOfOrigin] = this.ofOrigin;
        const countryLivingIn = this.player.livingIn?.name
            ? (0, country_1.getFlag)(this.player.livingIn.name)
            : globals_1.emdash;
        const stateLivingIn = this.player.livingIn?.state
            ? this.player.livingIn.state
            : globals_1.emdash;
        const cityLivingIn = this.player.livingIn?.city
            ? this.player.livingIn.city
            : globals_1.emdash;
        this.innerHTML += `
      <div id="player-personal-card">
        <div id="legend">
          <span>Email</span>

          <span>Nacionalidade(s)</span>
          <span>Estado(s) de Origem</span>
          <span>Cidade(s) de Origem</span>

          <span>País onde Mora</span>
          <span>Estado onde Mora</span>
          <span>Cidade Onde Mora</span>

          <span>Elo</span>
          <span>Dan Kyu</span>

          <span># de Partidas</span>
          <span>Última Partida</span>
        </div>

        <div id="content">
          <route-link href="mailto:${this.player.email}">
            <span>${email}</span>
          </route-link>

          <div id="nationalities">
            ${ui_utils_1.UiUtils.allFlags(this.player.nationalities)}
          </div>
          <span>${statesOfOrigin}</span>
          <span>${citiesOfOrigin}</span>

          <span>${countryLivingIn}</span>
          <span>${stateLivingIn}</span>
          <span>${cityLivingIn}</span>

          <span>${elo.num}</span>
          <span>${elo.danKyuLevel(true)}</span>

          <span>${this.player.gamesTotal}</span>
          <span>${ui_utils_1.UiUtils.lastGameLink(this.player)}</span>
        </div>
      </div>
    `;
    };
}
exports.default = PlayerView;
//# sourceMappingURL=data:application/json;base64,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